import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5d472e8a&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActiveBooking: require('/vercel/path0/components/ActiveBooking.vue').default,ToastAlert: require('/vercel/path0/components/ToastAlert.vue').default})
